import thirdMapper from '../../mappers/Third/third.mapper'
import { Third } from '../../schemas/Third'
import apiClient from '../apiClient'

class ThirdService {
  /** Creates a third party for the authenticated entity. */
  async saveThird(thirdData: Third) {
    try {
      const responseApi = await apiClient.post('/api/v2/third', thirdData)
      return responseApi.data
    } catch (error) {
      throw error
    }
  }

  /** Updates a third party for the authenticated entity. */
  async updateThird(thirdData: Third) {
    try {
      const responseApi = await apiClient.put('/api/v2/third', thirdData)
      return responseApi.data
    } catch (error) {
      throw error
    }
  }

  /** Lists third parties with optional pagination cursor. */
  async getThirds(params?: { limit: number, lastEvaluatedKey?: string }): Promise<{ lastEvaluatedKey: string, thirds: Third[] }> {
    try {
      let url = params !== undefined ? `/api/v2/third?limit=${params.limit}` : '/api/v2/third'

      if (params !== undefined && params.lastEvaluatedKey !== undefined) {
        url = `${url}&lastEvaluatedKey=${params.lastEvaluatedKey}`
      }

      const responseApi = await apiClient.get(url)

      const thirds = responseApi.data.thirds.map((third: any) => {
        return thirdMapper(third)
      })

      return {
        lastEvaluatedKey: JSON.stringify(responseApi.data.lastEvaluatedKey),
        thirds: thirds
      }

    } catch (error) {
      throw error
    }
  }

  /** Loads one third party by document number. */
  async getThirdByDocument(document: string): Promise<Third> {
    try {
      const responseApi = await apiClient.get(`/api/v2/third/${document}`)
      const third = thirdMapper(responseApi.data)
      return third
    } catch (error) {
      throw error
    }
  }
}

export default ThirdService
